/** The home prompt: one large, tightly set line in the body face. */
export function HomeHeading() {
  return (
    <h1 className="mb-8 text-[2.5rem] leading-[1.05] font-normal tracking-[-0.035em] text-balance">
      What do you want to know?
    </h1>
  );
}
